/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-07-28 10:25:21
 * @LastEditors: voanit
 * @LastEditTime: 2021-12-10 14:29:13
 */
export default [
  {
    path: '/stores',
    name: 'stores',
    redirect: { name: 'store' },
    component: () => import(/* webpackChunkName: "stores" */'@/views/store/list/index.vue')
  },
  {
    path: '/store',
    name: 'store',
    meta: {
      name: '店铺列表',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "stores" */'@/views/store/list/index.vue')
  },
  {
    path: '/stores/detail/:id',
    name: 'store-detail',
    meta: {
      name: '店铺详情',
      parentsName: 'store',
      backName: 'store',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "stores" */'@/views/store/detail/index.vue')
  },
  {
    path: '/stores/product/:id/shopName/:shopName',
    name: 'store-product',
    meta: {
      name: '商品管理',
      backName: 'store',
      keepAlive: true
      // keepAlive: false
    },
    component: () => import(/* webpackChunkName: "stores" */'@/views/store/product/index.vue')
  },
  {
    path: '/stores/paySetting',
    name: 'storePaySetting',
    meta: {
      name: '支付设置',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "stores" */'@/views/store/paySetting/index.vue')
  },
  {
    path: '/stores/shop-site',
    name: 'shop-site',
    meta: {
      name: '店铺设置',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "stores" */'@/views/store/shop-site/index.vue')
  },
  {
    path: '/stores/task-center',
    name: 'task-center',
    meta: {
      name: '任务中心',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "stores" */'@/views/store/task-center/index.vue')
  },
  {
    path: '/stores/sync-log',
    name: 'sync-log',
    meta: {
      name: '店铺同步日志',
      parentsName: 'store',
      backName: 'store',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "stores" */'@/views/store/sync-log/index.vue')
  },
]
